import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import {
  getLastSession,
  getNumberOfSessionModules
} from "seneca-common/features/session/selectors/session";
import { getNumberOfCompletedSessionModules } from "seneca-common/features/session/selectors/state/sessionModules";
import { getId } from "seneca-common/features/session/selectors/state/sessions/session";
import { useSelectorOnConditionWithArgs } from "seneca-common/utils/hooks/selectors";

import { matchSessionPath } from "../routes/classroom/routes/course/routes/section/routes/session/links";

export function useWarnOnNavigateAwayFromSession() {
  const location = useLocation();
  const lastSession = useSelector(getLastSession);
  const sessionId = lastSession && getId(lastSession);

  const numberOfSessionModules = useSelectorOnConditionWithArgs(
    !!sessionId,
    getNumberOfSessionModules,
    sessionId
  );

  const numberOfCompletedModules = useSelectorOnConditionWithArgs(
    !!sessionId,
    getNumberOfCompletedSessionModules,
    sessionId
  );

  return useMemo(() => {
    const sessionPathMatch = matchSessionPath(location.pathname);

    if (!sessionPathMatch) return false;
    if (!lastSession || lastSession.completed) return false;
    if (numberOfSessionModules === 0) return false;
    if (numberOfCompletedModules === 0) return false;

    return true;
  }, [
    location.pathname,
    lastSession,
    numberOfSessionModules,
    numberOfCompletedModules
  ]);
}
